import { stringifyRequestQuery } from 'app/components/Table/core/helpers';
import { ID, Response } from 'app/components/Table/core/types';

import { useHeartBeatStore } from 'app/modules/system-settings/locations/store';
import { ConnectStatusItem } from 'app/modules/system-settings/locations/wards/core/type';

import { isBoolean, uniqBy } from 'lodash';

import { API_URL } from 'app/constants/environments';

import { useNotificationStore } from '../store';
import { Notification, NotificationGroup, NotificationRequest } from './type';
import axios, { AxiosResponse } from 'axios';
import { useOrganizationStore } from 'theme/layout/components/aside/store';

const NOTIFICATIONS_URL = `${API_URL}/api`;
const NOTIFICATIONS_V2_URL = `${API_URL}/api`;

const getIsReadParam = (isRead?: boolean) => {
  return isBoolean(isRead) ? `&isRead=${isRead}` : '';
};

export const getNotificationGroups = (options: {
  page: number;
  onError?: () => void;
  isRead?: boolean;
  loadMore?: boolean;
  newNoti?: boolean;
  setLoading?: (loading: boolean) => void;
  orgId?: number;
}) => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;
  const { isRead, page, orgId, setLoading, onError } = options;
  if (page === 1) {
    useNotificationStore.getState().clearState();
  }

  setLoading?.(true);

  const params =
    `${NOTIFICATIONS_V2_URL}/orgs/${organizationId}/notifications/v2?${stringifyRequestQuery({
      page,
      limit: 1,
    })}${getIsReadParam(isRead)}` + (orgId ? `&orgId=${orgId}` : '');

  axios
    .get(params)
    .then(
      (
        res: AxiosResponse<{
          data: NotificationGroup;
        }>,
      ) => {
        const { items, total } = res.data.data;
        const curGroup = useNotificationStore.getState().state.notificationGroup;
        const newNotiGroups = uniqBy(curGroup.items.concat(items), 'day');
        useNotificationStore.getState().setState({
          notificationGroup: { items: newNotiGroups, total },
        });
      },
    )
    .catch(onError)
    .finally(() => {
      setLoading?.(false);
    });
};

export const changeStatusNotification = (
  idNoti: ID,
  request: NotificationRequest,
): Promise<Notification | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .patch(`${NOTIFICATIONS_URL}/orgs/${organizationId}/notifications/${idNoti}`, request)
    .then((response: AxiosResponse<Response<Notification>>) => response.data)
    .then((response: Response<Notification>) => response.data);
};

export const updateNotification = (request: NotificationRequest) => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .put(`${NOTIFICATIONS_URL}/orgs/${organizationId}/notifications`, request)
    .then((response: AxiosResponse<Response<Notification[]>>) => response.data)
    .then((response: Response<Notification[]>) => response.data);
};

export const getTotalUnreadNoti = async () => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  const dataRes = await axios
    .get(`${NOTIFICATIONS_URL}/orgs/${organizationId}/notifications/count?orgId=${organizationId}`)
    .then((response: AxiosResponse<Response<{ count: number }>>) => response.data.data);

  const fetched = useNotificationStore.getState().state.fetched;
  const initUnReadCount = useNotificationStore.getState().state.initUnReadCount;

  if (!dataRes) {
    return;
  }

  useNotificationStore.getState().setState({
    unReadCount: dataRes.count,
    fetched: true,
    initUnReadCount: fetched ? initUnReadCount : dataRes.count,
  });
};

//Get heart beat
export const getHeartBeat = async () => {
  const orgId = useOrganizationStore.getState().state.organization?.id;

  axios
    .get(`${NOTIFICATIONS_URL}/orgs/${orgId}/notifications/inventory-connection`)
    .then(
      (
        res: AxiosResponse<{
          data: ConnectStatusItem[];
        }>,
      ) => {
        const store = useHeartBeatStore;
        store.getState().clearState();

        store.getState().setState({ connectStatus: res.data.data });
      },
    )
    .catch(() => {
      return [];
    });
};
